// generated file, do not update manually !
export const sentryVersion = '263443603e0fe0e072fceb79c444059ecf07471e';
(window as any).SENTRY_RELEASE = { id: sentryVersion };
